"use strict";

exports.__esModule = true;
exports.PlantTwinContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of devices to consumers.
 *  @component
 **/

var PlantTwinContext = exports.PlantTwinContext = (0, _Utils.createEnhancedContext)({
  propName: "plantTwin"
});